module.exports = __webpack_public_path__ + "static/progetto_valtellinapalace1-88ff8ee8b85a02b61bd70f8f76b0ed43.jpg";